import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type ContextMenuCopyButtonClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};

export const onContextMenuCopyButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: ContextMenuCopyButtonClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}ContextMenuCopyButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			location: 'searchResultTitle',
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
